module.exports = __webpack_public_path__ + "static/media/available-android.c2320110.png";